'use strict';

import Forgot from './reducers/forgot.js';
import * as Redux from 'redux';

export default Redux.createStore(Forgot);
